module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG679db7b67dfab09bcc9193bf30e1242b.679db7b6.png";